import React, { useEffect, useRef, useState } from 'react';
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar';
import { makeStyles } from "@material-ui/core/styles";




const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));
const CreateDistributor = ()=>{
    
    const classes = useStyles();

    return(
        <div className="">
            <div className="cmail">
                <Top />
            </div>
            <div className="wrp-dashbord">
                <div className="cemail-left">
                    <Leftsiderbar />
                </div>
                <div className="right-section">
                    <div className="add-btn-wrp add-btn-wrp2">
                        <div className='button-div'>
                        <button className='create-button'>New Distributor</button>
                        <button className='create-button'>Edit Distributor</button>
                        </div>    
                    </div>
                </div>
            </div>

        </div>
    )
}
export default CreateDistributor;